import React, { useState } from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";

import BG from "../../../img/jpg/retailers/how-bg.jpg";
import ArrowIcon from "../../../img/png/retailers/arrow.png";
import HowIcon1 from "../../../img/svg/retailers/how-1.svg";
import HowIcon2 from "../../../img/svg/retailers/how-2.svg";
import HowIcon3 from "../../../img/svg/retailers/how-3.svg";
import HowIcon4 from "../../../img/svg/retailers/how-4.svg";
import ArrowVideosIcon from "../../../img/png/retailers/arrow-back.png";
import Clickable from "../../../components/Clickable";
import { useIsMobile } from "./../../../components/helpers/ScreenCheck";
import { useI18n } from "../../../i18n";

const How = () => {
  const [slide, setSlide] = useState(1);
  const isMobile = useIsMobile(1023);
  const { t } = useI18n();

  return (
    <div className={style.main}>
      <div className={style.container}>
        <p>
          {t("retailers_how_challenge")}
        </p>
        <h2>{t("retailers_how_title1")}</h2>
        <h2 className="last">{t("retailers_how_title2")}</h2>
        <img className="h1" src={HowIcon1} alt="" />
        <img className="h2" src={HowIcon2} alt="" />
        <img className="h3" src={HowIcon3} alt="" />
        <img className="h4" src={HowIcon4} alt="" />
        <img className="arrow" src={ArrowIcon} alt="" />
      </div>
      <div className={style.animation}>
        <video
          playsInline
          webkit-playsinline
          autoPlay
          loop
          muted
          style={{ display: slide === 1 ? "block" : "none" }}
        >
          <source
            src={
              isMobile
                ? "/videos/mobile/mobile_adaption_01.mp4"
                : "/videos/desktop/animated_numbers_01.mp4"
            }
            type="video/mp4"
          />
        </video>
        <video
          playsInline
          webkit-playsinline
          autoPlay
          loop
          muted
          style={{ display: slide === 2 ? "block" : "none" }}
        >
          <source
            src={
              isMobile
                ? "/videos/mobile/mobile_adaption_02.mp4"
                : "/videos/desktop/animated_numbers_02.mp4"
            }
            type="video/mp4"
          />
        </video>
        <video
          playsInline
          webkit-playsinline
          autoPlay
          loop
          muted
          style={{ display: slide === 3 ? "block" : "none" }}
        >
          <source
            src={
              isMobile
                ? "/videos/mobile/mobile_adaption_03.mp4"
                : "/videos/desktop/animated_numbers_03.mp4"
            }
            type="video/mp4"
          />
        </video>
        <video
          playsInline
          webkit-playsinline
          autoPlay
          loop
          muted
          style={{ display: slide === 4 ? "block" : "none" }}
        >
          <source
            src={
              isMobile
                ? "/videos/mobile/mobile_adaption_04.mp4"
                : "/videos/desktop/animated_numbers_04.mp4"
            }
            type="video/mp4"
          />
        </video>
        <h3>{t("retailers_how_stats")}</h3>
        <Clickable
          className="prev"
          onClick={() => setSlide(slide === 1 ? 4 : slide - 1)}
        >
          <img src={ArrowVideosIcon} alt={t("retailers_how_alt_prev")} />
        </Clickable>
        <Clickable
          className="next"
          onClick={() => setSlide(slide === 4 ? 1 : slide + 1)}
        >
          <img src={ArrowVideosIcon} alt={t("retailers_how_alt_next")} />
        </Clickable>
      </div>
    </div>
  );
};

const style = {
  main: css({
    backgroundColor: "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",

    [desktop]: {},
    [laptop]: {},
    [tablet]: {},
  }),
  animation: css({
    position: "relative",
    height: 900,
    width: "100%",
    backgroundColor: "#000",
    overflow: "hidden",

    video: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      maxWidth: 1500,
      left: -100,
      top: -50,
      zIndex: "0",
    },
    h3: {
      color: "#FFF",
      fontFamily: "Syne",
      fontSize: 90,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "105px",
      width: 774.062,
      position: "absolute",
      top: 101,
      left: 119,
    },
    span: {
      width: 68,
      height: 95,
      position: "absolute",
      bottom: 331,
      right: 50,
      transform: "rotate(180deg)",

      img: {
        width: "100%",
        height: "100%",
      },
      "&.prev": {
        right: 130,
        transform: "rotate(0deg)",
      },
    },
    [desktop]: {
      h3: {
        fontSize: 65.146,
        lineHeight: "76.314px",
        top: 73.88,
        left: 87.04,
        width: 566,
      },
      span: {
        width: 49.74,
        height: 69.49,
        bottom: 180,

        "&.prev": {
          right: 110,
          transform: "rotate(0deg)",
        },
      },
    },
    [laptop]: {
      height: 1122,
      marginRight: 0,
      paddingRight: 0,

      video: {
        position: "absolute",
        width: "100%",
        height: 800,
        objectFit: "cover",
        left: 0,
        top: 0,
        zIndex: "0",
        padding: 40,
      },
      h3: {
        fontSize: 60,
        lineHeight: "72px",
        top: 60,
        left: 40,
        width: 538,
      },
      span: {
        width: 49.74,
        height: 69.49,
        bottom: 60,
        left: 0,
        right: -60,
        margin: "auto",

        "&.prev": {
          left: -60,
          right: 0,
          margin: "auto",
          transform: "rotate(0deg)",
        },
      },
    },
    [tablet]: {
      height: 670,

      video: {
        height: 464,
        padding: 0,
        paddingTop: 60,
      },
      h3: {
        fontSize: 36,
        lineHeight: "42px",
        top: 62,
        left: 33,
        maxWidth: 308,
        marginRight: 33,
      },
      span: {
        width: 51.54,
        height: 72,
        bottom: 40,
      },
    },
  }),
  container: css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    paddingTop: 90,
    paddingBottom: 140,

    p: {
      maxWidth: 932,
      width: "100%",
      color: "#000",
      textAlign: "center",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "normal",
      letterSpacing: 0.36,
      marginBottom: 104,
    },
    h2: {
      color: "#151B27",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 76.5,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "91.562px",
      marginRight: 240,

      "&.last": {
        marginRight: 0,
        marginLeft: 240,
      },
    },
    img: {
      position: "absolute",

      "&.h1": {
        marginLeft: -520,
        top: 180,
        width: 77.39,
        height: 52.512,
      },
      "&.h2": {
        marginLeft: -100,
        top: 150,
        width: 296,
        height: 146,
      },
      "&.h3": {
        marginLeft: 800,
        top: 140,
        width: 214.725,
        height: 201.397,
      },
      "&.h4": {
        marginLeft: -800,
        bottom: 60,
        width: 193,
        height: 139,
      },
      "&.arrow": {
        bottom: "-250px",
        marginLeft: 800,
        zIndex: 1,
      },
    },

    [desktop]: {
      paddingTop: 111,
      paddingBottom: 150,

      p: {
        maxWidth: 658,
        marginBottom: 109,
      },
      h2: {
        fontSize: 65.45,
        lineHeight: "79px",
        marginRight: 200,

        "&.last": {
          marginRight: 0,
          marginLeft: 200,
        },
      },
      img: {
        position: "absolute",

        "&.h1": {
          marginLeft: -520,
          top: 240,
          width: 77.39,
          height: 52.512,
        },
        "&.h2": {
          marginLeft: -100,
          top: 200,
          width: 226,
          height: 116,
        },
        "&.h3": {
          marginLeft: 680,
          top: 220,
          width: 180,
          height: 178,
        },
        "&.h4": {
          marginLeft: -700,
          bottom: 80,
          width: 165,
          height: 120,
        },
        "&.arrow": {
          width: 144,
          height: 216,
          bottom: "-140px",
          marginLeft: 600,
          zIndex: 1,
        },
      },
    },
    [laptop]: {
      paddingTop: 132,
      paddingBottom: 132,

      p: {
        maxWidth: 542,
        marginBottom: 200,
      },
      h2: {
        fontSize: 44.2,
        lineHeight: "58px",
        marginRight: 50,

        "&.last": {
          marginRight: 0,
          marginLeft: 50,
        },
      },
      img: {
        position: "absolute",

        "&.h1": {
          marginLeft: -440,
          top: 320,
          width: 77.39,
          height: 52.512,
        },
        "&.h2": {
          marginLeft: -0,
          top: 280,
          width: 226,
          height: 116,
        },
        "&.h3": {
          marginLeft: 480,
          top: 300,
          width: 180,
          height: 178,
        },
        "&.h4": {
          marginLeft: -500,
          bottom: 40,
          width: 165,
          height: 120,
        },
        "&.arrow": {
          width: 144,
          height: 216,
          bottom: "-140px",
          marginLeft: 600,
          zIndex: 1,
        },
      },
    },
    [tablet]: {
      paddingTop: 58.5,
      paddingBottom: 58.5,

      p: {
        fontSize: 16,
        maxWidth: 349,
        marginBottom: 96,
      },
      h2: {
        fontSize: 27.2,
        lineHeight: "38px",
        marginRight: 0,
        textAlign: "center",

        "&.last": {
          marginRight: 0,
          marginLeft: 0,
        },
      },
      img: {
        position: "absolute",

        "&.h1": {
          marginLeft: -240,
          top: "50%",
          width: 67,
          height: 48,
        },
        "&.h2": {
          marginLeft: -0,
          top: "50%",
          width: 146,
          height: 70,
        },
        "&.h3": {
          marginLeft: 280,
          top: "40%",
          width: 120,
          height: 110,
        },
        "&.h4": {
          marginLeft: -270,
          bottom: 10,
          width: 82,
          height: 60,
        },
        "&.arrow": {
          width: 70.6,
          height: 106,
          bottom: "-68px",
          marginLeft: 0,
          right: 20,
          zIndex: 1,
        },
      },
    },
  }),
};

export default How;
